import HttpService from './http';

export default class ProductHttpService {
  static get = async uid => {
    const url = `/v2.0/products/${uid}`;
    return await HttpService.get(url, false);
  };

  static listOfVendor = async payload => {
    const { vendor_uid, filters, page } = payload;
    const url = `/v2.0/products/vendor/${vendor_uid}/active?page=${page}&filters=${filters}`;
    return await HttpService.get(url, false);
  };

  static listOfEvent = async payload => {
    const { event_uid, filters, page } = payload;
    const url = `/v2.0/products/event/${event_uid}?page=${page}&filters=${filters}`;
    return await HttpService.get(url, false);
  };
}
